module.exports = {"id":"about-pcgc","title":"About PCGC","content":"<h1>About PCGC</h1>\n"}